module.exports = __webpack_public_path__ + "static/media/EduladeLogo.4745abfd.png";